import { render, staticRenderFns } from "./KnFormProduct.vue?vue&type=template&id=68a1f06e"
import script from "./KnFormProduct.js?vue&type=script&lang=js&external"
export * from "./KnFormProduct.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports